export default {
  showChangelog: 'Alle Versionshinweise anzeigen',
};
